/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'BusinessService';
export const filterTitle = t`Business Service`;
export const entityType = ENTITY_TYPES.BUSINESS_SERVICE;

export function useBusinessService() {
    return useEntity(filterId);
}

export function useBusinessServiceName() {
    return useEntityName(filterId);
}

function BusinessServiceFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

BusinessServiceFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

BusinessServiceFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/business-service-detail',
                pageStateParams: ['SelectedTime'],
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(BusinessServiceFilter);
